import styles from './StatusCell.module.scss';
import { ReactElement } from 'react';
import BadgeDot, { BadgeStatus } from '../badge-dot/BadgeDot';

interface StatusCellProps {
  label: string;
  status: BadgeStatus;
  size?: 'small' | 'medium' | 'large';
}

export function StatusCell({ label, status, size = 'medium' }: StatusCellProps): ReactElement {
  return (
    <span className={`${styles.statusCell} ${styles[`statusCell--${size}`]}`}>
      <span className={styles.statusCell__badge}>
        <BadgeDot status={status} />
      </span>
      {label}
    </span>
  );
}

export default StatusCell;
